module.exports = __webpack_public_path__ + "assets/be33e5ce26e7b50636cc1b72d5af9c53.png";